import { render } from "./HomeIndex.vue?vue&type=template&id=6d5f5b5c"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__